import { generateAuthActions, generateRequireSignInWrapper } from 'redux-token-auth';
import { authUrl } from './constants';

const config = {
  authUrl,
  userAttributes: {
    id: 'id',
    loginName: 'login',
    roles: 'roles'
  }
}

const {
  signInUser,
  signOutUser,
  verifyCredentials
} = generateAuthActions(config)

const requireSignIn = generateRequireSignInWrapper({
  redirectPathIfNotSignedIn: '/login',
})

export {
  signInUser,
  signOutUser,
  verifyCredentials,
  requireSignIn
}



// WEBPACK FOOTER //
// ./src/authentication/javascripts/redux-token-auth-config.js